
export default {
  name: 'rzTooltip',
  props: {
    dialogBottom: Boolean,
  },
};
